"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ExternalLink = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _assets = _interopRequireDefault(require("../../preact-components/assets"));

var ExternalLink = function ExternalLink(_ref) {
  var label = _ref.label,
      url = _ref.url,
      _ref$isExternalLinkFo = _ref.isExternalLinkForToggle,
      isExternalLinkForToggle = _ref$isExternalLinkFo === void 0 ? true : _ref$isExternalLinkFo;
  var labelClassName = isExternalLinkForToggle ? 'how-to-link-for-toggle' : 'how-to-link-for-block';
  return (0, _preact.h)("div", {
    className: "how-to-with-icon"
  }, (0, _preact.h)("a", {
    href: (0, _absoluteUrlRuntime.resolveUrl)(url),
    target: "_blank"
  }, (0, _preact.h)("span", {
    className: labelClassName
  }, " ", label), (0, _preact.h)(_assets.default, {
    customClass: "icon-open-in-new",
    icon: "externalLink",
    width: 16,
    height: 16
  })));
};

exports.ExternalLink = ExternalLink;